<div class="row">
  <div class="col-6">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings" [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="this.playerHardwareId" class="my-4">
                {{'lang.devices.editDeviceHardware' | translate}}</h3>
              <h3 *ngIf="!this.playerHardwareId" class="my-4">
                {{'lang.devices.createDeviceHardware' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Name">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Name" class="form-control" formControlName="Name"
                           sbAutofocus>
                    <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger">
                      {{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label" for="Manufacturer">{{'lang.devices.editDeviceHardware.manufacturer' |
                    translate}}</label>
                  <sb-comp-dropdown-select
                    id="Manufacturer"
                    class="mt-5"
                    *ngPermissions="[permissionService.Permission.company_list]"
                    [singleSelectMode]="true" [showSubmit]="false"
                    [inputData]="manufacturers" [dropDownDatatype]="'COMPANIES'"
                    (selectedDataEmitter)="update($event, 'COMPANIES')" [showColumnIcon]="false"
                    [msOptions]="msCompanyOptions" (msOptionsChange)="msRequest('COMPANIES', $event)"
                    [selectedInputData]="playerHardware?.manufacturer ? [playerHardware?.manufacturer] : []">
                  </sb-comp-dropdown-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="OS">{{'lang.devices.editDeviceHardware.os' | translate}}<span
                      class="red">*</span></label>
                    <input type="text" id="OS" class="form-control" formControlName="OS">
                    <div *ngIf="OS.touched && OS.errors?.required" class="alert alert-danger">
                      {{'lang.devices.editDeviceHardware.osWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Version">{{'lang.devices.editDeviceHardware.version' |translate}}<span
                      class="red">*</span></label>
                    <input type="text" id="Version" class="form-control" formControlName="Version">
                    <div *ngIf="Version.touched && Version.errors?.required"
                         class="alert alert-danger">
                      {{'lang.devices.editDeviceHardware.verionsWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                    <input type="text" id="Description" class="form-control"
                           formControlName="Description">
                  </div>
                </div>
              </div>
              <!--
                  <div class="row">
                      <div class="col-md-5">
                          <div class="header-wrapper" style="position: relative;">
                              <div class="userPicEdit userPicEditFar cursor-pointer"
                                  (click)="pickDepiction()">
                                  <sb-icon class="icon-center" icon="edit"></sb-icon>
                              </div>
                              <img style="object-fit: cover; height: auto; width: 100%;" [src]="depictionUrl"
                                  alt="./assets/img/channel-placeholder.png" />
                          </div>
                      </div>
                  </div>
              --->
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.playerHardware)"
                           class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' |
                  translate}}
                </button>
                <button (click)="updatePlayerHardware()"  type="button"
                           [disabled]="!form.valid || loading" class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
